import { Briefcase, Building2, CalendarX, ClipboardList, Gavel, ShieldCheck } from "lucide-react";

// سجل التقارير: أضف تقريراً جديداً بمدخل واحد هنا (feature اختياري لتقييده بمفتاح ميزة).
export const REPORT_TABS = [
  { key: "attendance", icon: ClipboardList },
  { key: "entities", icon: Building2 },
  { key: "absences", icon: CalendarX },
  { key: "duties", icon: Briefcase, feature: "duties" },
  { key: "penalties", icon: Gavel, feature: "penalties" },
  { key: "verify", icon: ShieldCheck },
];

export const REPORT_KEYS = REPORT_TABS.map((tab) => tab.key);

export const visibleReportTabs = (features) =>
  REPORT_TABS.filter((tab) => !tab.feature || features?.[tab.feature]);
